"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCondensedTable = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCondensedTable = styled_components_1.default.table(function (_a) {
    var _b = _a.theme, colors = _b.colors, space = _b.space, fontWeights = _b.fontWeights;
    return "\n    tr {\n      background: ".concat(colors.canvas, ";\n    }\n\n    caption {\n      font-weight: ").concat(fontWeights.normal, ";\n    }\n\n    caption,\n    th,\n    td {\n      white-space: normal;\n      padding-top: ").concat(space[1], ";\n      padding-bottom: ").concat(space[1], ";\n\n      &:first-child {\n        padding-left: 0;\n      }\n      &:last-child {\n        padding-right: 0;\n        text-align: right;\n      }\n    }\n  ");
});
